import { render, staticRenderFns } from "./CertificatePopUp.vue?vue&type=template&id=b34224d6&"
import script from "./CertificatePopUp.vue?vue&type=script&lang=js&"
export * from "./CertificatePopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b34224d6')) {
      api.createRecord('b34224d6', component.options)
    } else {
      api.reload('b34224d6', component.options)
    }
    module.hot.accept("./CertificatePopUp.vue?vue&type=template&id=b34224d6&", function () {
      api.rerender('b34224d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/security/CertificatePopUp.vue"
export default component.exports